export default "<span class=\"mention\">\n    <ng-content></ng-content>\n</span>\n";